<template>
  <Comments :params="params" :key="version" />
</template>

<script>
import {defineComponent, onMounted, ref} from "vue"
import Comments from "@/modules/comments/pages/comments/components/comments/Comments"

export default defineComponent({
  name: "TelegramComments",
  components: {
    Comments
  },
  setup() {
    let version = ref(0)

    let params = {
      title: "Комментарии в Telegram",
      h1: "Комментарии в Telegram",
      page: "telegram_comments",
      channels: [2, 3, 4, 5, 7, 8, 9, 10, 11, 12],
    }

    onMounted(() => {
      version.value++
    })

    return {
      params,
      version,
    }
  }
})
</script>

<style scoped>

</style>
